import * as React from "react";
import {Helmet} from "react-helmet";
import {graphql, useStaticQuery} from "gatsby";
import {useI18next} from "gatsby-plugin-react-i18next";

interface SEOProps {
	title: string;
	meta?: {
		name: string;
		content: string;
	}[]
}

export const SEO: React.FC<SEOProps> = (props) => {
	const {language} = useI18next();
	const {site} = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						name
					}
				}
			}
		`
	);
	const defaultTitle = site.siteMetadata.title;
	const metaDescription = 'Odania Gaming';
	return (
		<Helmet
			htmlAttributes={{
				lang: language,
			}}
			meta={[
				{
					name: `description`,
					content: metaDescription,
				},
				{
					property: `og:title`,
					content: props.title,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata?.author || ``,
				},
				{
					name: `twitter:title`,
					content: props.title,
				},
				{
					name: `twitter:description`,
					content: metaDescription,
				},
			].concat(props.meta ?? [])}
			title={props.title}
			titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
			script={[
				{
					id: 'zsiqchat',
					type: 'text/javascript',
					innerHTML: 'var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "f589f59481ce309ac19d5af4c8559db2efe179da4b584678ef1a59dca58b9459", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.eu/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);',
				},
			]}
		/>
	);
};
